import { AfterViewInit, Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { FloatLabel } from 'primeng/floatlabel';
import { IftaLabel } from 'primeng/iftalabel';
import { Fluid } from 'primeng/fluid';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSwitch } from '@angular/common';
import { style } from '@angular/animations';

export interface InputNumberTemplateOptions {
  // Basic properties
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  size?: 'small' | 'large';
  variant?: 'filled' | 'outlined';
  description?: string;
  
  // Number properties
  mode?: 'decimal' | 'currency';
  min?: number;
  max?: number;
  step?: number;
  minFractionDigits?: number;
  maxFractionDigits?: number;
  useGrouping?: boolean;
  
  // Currency properties
  currency?: string;
  currencyDisplay?: 'symbol' | 'code' | 'name';
  
  // Locale
  locale?: string;
  
  // Prefix & Suffix
  prefix?: string;
  suffix?: string;
  
  // Buttons
  showButtons?: boolean;
  buttonLayout?: 'stacked' | 'horizontal' | 'vertical';
  
  // Style & Class
  inputStyle?: { [key: string]: any };
  inputStyleClass?: string;
  styleClass?: string;
  
  // Accessibility
  ariaLabel?: string;
  ariaLabelledBy?: string;
  
  // Templates
  incrementButtonIcon?: string;
  decrementButtonIcon?: string;
  
  // Float/Ifta Label
  floatLabel?: 'over' | 'in' | 'on';
  iftaLabel?: boolean;
  
  // Events
  onInput?: (event: any) => void;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  onKeyDown?: (event: any) => void;
}

@Component({
  selector: 'formly-field-inputnumber',
  templateUrl: './formly-inputnumber.component.html',
  styleUrls: ['./formly-inputnumber.component.css'],
  standalone: true,
  imports: [
    InputNumber,
    FloatLabel,
    IftaLabel,
    ReactiveFormsModule,
    FormsModule,
    FormlyModule,
    InputNumberModule
  ]
})
export class FormlyFieldInputNumber extends FieldType<FieldTypeConfig<InputNumberTemplateOptions>> implements OnInit, AfterViewInit {
  @ViewChild('inputNumber') inputNumber!: InputNumber;
  
  override defaultOptions = {
    templateOptions: {
      mode: 'decimal' as const,
      useGrouping: true,
      variant: 'outlined' as const,
      size: undefined,
      buttonLayout: 'stacked' as const,
      showButtons: false,
      readonly: false,
      styleClass: 'width: 100%;',
    }
  };

  ngOnInit() {
    if (!this.to.locale) {
      this.to.locale = 'hu-HU'; //Alapból magyar
    }
  }

  ngAfterViewInit() {
    this.handleDisabledState();
  }

  private handleDisabledState() {
    if (this.to.disabled) {
      if (this.formControl.enabled) {
        this.formControl.disable();
      }
    } else {
      if (this.formControl.disabled) {
        this.formControl.enable();
      }
    }
  }

  override get to(): InputNumberTemplateOptions {
    return this.field.templateOptions || {};
  }

  getWrapperType(): string {
    if (this.to.floatLabel) return 'floatlabel';
    if (this.to.iftaLabel) return 'iftalabel';
    return 'standard';
  }

  onInput(event: any) {
    if (this.to.onInput) {
      this.to.onInput(event);
    }
  }

  onFocus(event: any) {
    if (this.to.onFocus) {
      this.to.onFocus(event);
    }
  }

  onBlur(event: any) {
    if (this.to.onBlur) {
      this.to.onBlur(event);
    }
  }

  onKeyDown(event: any) {
    if (this.to.onKeyDown) {
      this.to.onKeyDown(event);
    }
  }
}